import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from '../../../assets/images'
import { LoginWithMobileNumberPayloadType } from '../../../commonTypes/authTypes'
import { countryCode } from '../../../constant/countryCode'
import { Checkbox, DropDown } from '../../commons'
type AppProps = {
    inputDetails: any;
    countryDialCode: any;
    setInputDetails: (data: any) => void;
    setCountryDialCode: (data: any) => void;
    handleMobileOtpSend: (data: LoginWithMobileNumberPayloadType) => void;
}
const LoginWithMobileNumber = ({
    inputDetails,
    countryDialCode,
    setCountryDialCode,
    setInputDetails,
    handleMobileOtpSend
}: AppProps) => {
    const [checkBox, setCheckBox] = useState<boolean>(false);

    const handleCountryCode = (mode: any) => {
        setCountryDialCode({
            label: `${mode?.label?.split("").slice(0, 4).join("")} (${mode?.value})`,
            value: mode?.value
        })
    }

    const option: any = countryCode?.map((e) => {
        return {
            label: `${e.flag} ${e.name}(${e.dial_code})`,
            value: e.dial_code
        }
    })

    const handleInputChange = (e: any) => {
        const Value = e.target.value;
        setInputDetails((prev: any) => ({
            ...prev,
            mobileNumber: Value
        }))
    }

    const handleSendOtp = () => {
        setInputDetails((prev: any) => ({
            ...prev,
            otp: ''
        }))
        let finalData = {
            countryCode: countryDialCode?.value,
            mobileNumber: inputDetails?.mobileNumber
        }
        handleMobileOtpSend(finalData)
    }

    const handleMaxLengthCheck = (e: any) => {
        if (e?.target.value.length > e?.target.maxLength) {
            e.target.value = e.target.value.slice(0, e.target.maxLength);
            setInputDetails((prev: any) => ({
                ...prev,
                otp: e?.target.value
            }))
        }
    };

    const handleCheckBox=()=>{
        setCheckBox(!checkBox)
    }

    const selectStyle = {
        option: (baseStyles: any, state: any) => ({
            ...baseStyles,
            width: '350px',
        }),
        control: (provided: any, state: any) => ({
            ...provided,
            width: '140px',
            fontSize: '17px'
        }),
        container: (provided: any) => ({
            ...provided,
            width: 365,
            position: 'absolute'
        })
    }

    return (
        <>
            <div className='mt-5 mobilediv'>
                <span>
                    <span></span>
                    <Link to='/' className='back-to-login mb-3'><img src={ArrowLeft} />Back to Login</Link>
                    <h5 className='mt-3 mb-2'>Enter Mobile Number</h5>
                    <p className='description'>To verify your account, we will send 6 digit OTP number to your registered number.</p>
                </span>
                <label className='mb-2'>Enter mobile number</label>
                <div className='phone-number-container'>
                    <div style={{ marginLeft: '-12px' }}
                    >
                        <DropDown
                            options={option}
                            value={countryDialCode}
                            handleChange={handleCountryCode}
                            style={selectStyle}
                            disabled
                        />
                    </div>
                    <div style={{ zIndex: 1, marginLeft: '145px', width: "260px" }}>
                        <input
                            type="number"
                            className='form-control'
                            name="phone"
                            value={inputDetails?.mobileNumber}
                            autoFocus
                            onChange={handleInputChange}
                            onWheel={event => event.currentTarget.blur()}
                            maxLength={15}
                            onInput={handleMaxLengthCheck}
                        />
                    </div>
                </div>
                <div className='d-flex'>
                                <span className='mt-1'>
                                    <Checkbox
                                        checked={checkBox}
                                        onPress={handleCheckBox}
                                    />
                                    </span>
                                    <span className='ml-2'>I agree to the <a style={{color:'#dd4433',textDecoration:"underline",textUnderlineOffset: "2px"}} href='https://akssai.com/terms-conditions/' target='_blank'>Terms of Service</a> and <a style={{color:'#dd4433',textDecoration:"underline",textUnderlineOffset: "2px"}} href='https://akssai.com/privacy-policy/' target='_blank'>Privacy Policy</a></span>
                            </div>
                <div className="mb-3 mt-3">
                    <button type="submit" className="btn btn-primary w-100"
                        disabled={!inputDetails?.mobileNumber || !checkBox}
                        onClick={handleSendOtp}
                    >
                        Send OTP
                    </button>
                </div>
                <div className='text-center mb-4'>
                    <p className='mt-4 mb-0'>Created account using email?</p>
                    <Link to='/' className='back-to-login'>Login with Email & Password</Link>
                </div>
            </div>
        </>
    )
}

export default LoginWithMobileNumber